import { calendarHistoryMiddleware } from '@organisms/calendar/common/redux/middleware';
import { cartMiddleware } from '@pages/cart/store/cartMiddleware';
import { configureStore } from '@reduxjs/toolkit';

import rootReducer from './rootReducer';

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(cartMiddleware, calendarHistoryMiddleware),
});

export default store;
